import { Box, Grid, TextField, Button } from '@mui/material'

export function BackendSettings() {
  return (
    <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid container item>
            <TextField label="URL" size="small" id="outlined-basic" variant="outlined" type="text" defaultValue={'http://localhost'} />
          </Grid>
          <Grid container item>
            <TextField label="ポート番号" size="small" id="outlined-basic" variant="outlined" type="number" defaultValue={3001} />
          </Grid>
          <Grid container item>
            <Button variant="contained">接続</Button>
          </Grid>
        </Grid>
    </Box>
  );
}

export default BackendSettings;
